import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import tetrazolioService, { TetrazolioDetalhes } from '../../../../services/sementes/tetrazolio';
import { selectTopBarState } from '../../../../components/Topbar/topBarSlice';

interface UseTetrazolioDetalhesResult {
  detalhes: TetrazolioDetalhes | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export default function useTetrazolioDetalhes(id: string): UseTetrazolioDetalhesResult {
  const [detalhes, setDetalhes] = useState<TetrazolioDetalhes | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { currentProdutor } = useSelector(selectTopBarState);

  useEffect(() => {
    if (!id || !currentProdutor?.id) {
      setLoading(true);
      return;
    }

    const fetchDetalhes = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await tetrazolioService.getById(id, currentProdutor.id);
        setDetalhes(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Erro ao carregar detalhes');
        setDetalhes(null);
      } finally {
        setLoading(false);
      }
    };

    fetchDetalhes();
  }, [id, currentProdutor?.id]);

  const refetch = useCallback(async () => {
    if (!id || !currentProdutor?.id) {
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const data = await tetrazolioService.getById(id, currentProdutor.id);
      setDetalhes(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao carregar detalhes');
      setDetalhes(null);
    } finally {
      setLoading(false);
    }
  }, [id, currentProdutor?.id]);

  return {
    detalhes,
    loading,
    error,
    refetch,
  };
}
